import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    t: "1685599465763",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "1670",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "200",
    height: "200"
};
export function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock("svg", _hoisted_1, [
        ..._cache[0] || (_cache[0] = [
            _createElementVNode("path", {
                d: "M174.08 447.488c17.408 0 30.72-13.312 30.72-30.72V236.544c0-18.432 14.336-32.768 31.744-32.768h550.912c18.432 0 32.768 14.336 32.768 32.768v180.224c0 17.408 13.312 30.72 30.72 30.72s30.72-13.312 30.72-30.72V236.544c0-51.2-40.96-93.184-93.184-94.208H236.544c-51.2 0-93.184 41.984-93.184 94.208v180.224c0 17.408 13.312 30.72 30.72 30.72zM851.968 585.728c-17.408 0-30.72 13.312-30.72 30.72v180.224c0 18.432-14.336 32.768-31.744 32.768H237.568c-18.432 0-32.768-14.336-32.768-32.768V617.472c0-17.408-13.312-30.72-30.72-30.72s-30.72 13.312-30.72 30.72v179.2c-1.024 24.576 9.216 48.128 26.624 66.56 17.408 18.432 40.96 27.648 67.584 27.648l4.096-1.024h547.84c51.2 0 93.184-41.984 93.184-94.208V616.448c0-16.384-14.336-30.72-30.72-30.72zM227.328 510.976c0-29.696-24.576-54.272-54.272-54.272s-54.272 24.576-54.272 54.272 24.576 54.272 54.272 54.272 54.272-24.576 54.272-54.272zM851.968 456.704c-29.696 0-54.272 24.576-54.272 54.272s24.576 54.272 54.272 54.272 54.272-24.576 54.272-54.272-24.576-54.272-54.272-54.272z",
                "p-id": "1671"
            }, null, -1)
        ])
    ]);
}
